import { TableException } from "./TableException";

export class ProductNotFound extends TableException {

    constructor ({ sku, name}) {
        super(`O item "${sku} - ${name}" não foi encontrado`);
        this.productName = name;
        this.productSku = sku;
    }

    get variables () {
        return {
            sku: this.productSku,
            name: this.productName
        }
    }

    get template () {
        return "itemNotFound";
    }

}
